export default "__VITE_ASSET__CpIWJ2t6__"